import React from "react";
import Confetti from "react-confetti";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Transition, TransitionGroup } from "react-transition-group";
import mixpanel from "mixpanel-browser";
import onboardingActionCreators from "~/store/onboarding/actions";
import styled from "styled-components";
import Text from "~/components-shared/Text";
import Button from "~/components-shared/Button";
import { enterOnboardingComplete, exitOnboardingComplete } from "~/lib/animations";
import { StatusStateEnum } from "~/types/enums";
import onboardingSelectors from "~/store/onboarding/selectors";
import { Alert } from "~/components-shared";
const Wrapper = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  backdrop-filter: blur(3px);
  z-index: 12;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const Container = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;
`;
const StyledText = styled(Text)`
  max-width: 500px;
`;
const OnboardingComplete = _ref => {
  let {
    open
  } = _ref;
  const {
    t
  } = useTranslation();
  const dispatch = useDispatch();
  const status = useSelector(onboardingSelectors.getStatus);
  const error = useSelector(onboardingSelectors.getError);
  const onSubmit = () => {
    dispatch(onboardingActionCreators.completeSubmitStarted());
    mixpanel.track(`Onboarding Complete – Get Started`);
  };
  return /*#__PURE__*/React.createElement(TransitionGroup, {
    component: null
  }, /*#__PURE__*/React.createElement(Transition, {
    key: open,
    onEnter: node => enterOnboardingComplete(node),
    onExit: node => exitOnboardingComplete(node),
    timeout: {
      enter: 750,
      exit: 400
    },
    appear: true
  }, open ? /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Confetti, {
    width: window.innerWidth,
    height: window.innerHeight
  }), error && /*#__PURE__*/React.createElement(Alert, {
    severity: "danger",
    s: {
      mb: 3
    },
    fullWidth: true
  }, error), /*#__PURE__*/React.createElement(Text, {
    element: "h2",
    fontSize: 20,
    className: "anim__complete-icon"
  }, "\uD83C\uDF89"), /*#__PURE__*/React.createElement(Text, {
    element: "h1",
    fontSize: 16,
    weight: "semiBold",
    s: {
      mb: 3
    },
    className: "anim__complete-title"
  }, t("OnboardingComplete.youAreSetUp")), /*#__PURE__*/React.createElement(StyledText, {
    element: "span",
    weight: "semiBold",
    fontSize: 5,
    lineHeight: 8,
    s: {
      mb: 3
    },
    className: "anim__complete-info"
  }, t("OnboardingComplete.description")), /*#__PURE__*/React.createElement(Button, {
    onClick: onSubmit,
    rounded: true,
    s: {
      mt: 6,
      px: 10,
      py: 6
    },
    fontSize: 6,
    className: "anim__complete-button",
    loading: status === StatusStateEnum.LOADING,
    shadow: true
  }, t("OnboardingComplete.getStarted")))) : /*#__PURE__*/React.createElement("div", null)));
};
export default OnboardingComplete;